export const en = {
  texts: {
    text1: `If you have problems with your camera or microphone, please check your browser's permissions.`,
    text2: `Browser help links:`,
  },
};
